import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { useFormikContext, useField } from 'formik'

// Components
import Item from './components/Item'
import ErrorMessage from './components/ErrorMessage'

// Variables / Functions
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  showError: PropTypes.bool,
}

export const defaultProps = {
  onChange: () => {},
  showError: false,
}

function RadioField(props) {
  const { children, className, name, onChange: onChangeProps, error, showError } = props

  const [field] = useField(props)
  const { setFieldValue } = useFormikContext()

  const onChange = (event) => {
    const value = event.target.value

    setFieldValue(field.name, value)
    onChangeProps()
  }

  const RadioFieldChildren = React.Children.map(children, (child) => {
    const isChecked = field.value === child?.props.value

    if (!child) return

    return React.cloneElement(child, {
      onChange,
      name,
      checked: isChecked,
    })
  })

  return (
    <div className={cx('radio-field-wrapper', className)}>
      {RadioFieldChildren}
      {showError && <ErrorMessage wrapperClassName={className} name={name} customError={error} />}
    </div>
  )
}

RadioField.propTypes = propTypes
RadioField.defaultProps = defaultProps

RadioField.Item = Item

export default RadioField
